import React, {useReducer, useRef, useState} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import FeatureName from "../../visComponents/featureName";
import AllFeaturesChecker from "../../visComponents/allFeaturesChecker";
import {EditIcon} from "../../common/icons";
import {getCurrentLayout} from "../../appLayout";
import {useOutsideClick} from "../../../misc/helperHooks";
//import {getNavItemsFromTheWizard} from "../../sqft/helpers/sqftHelperUi";
import sqftShapeManager from "../../sqft/components/canvas/store/sqftShapeManager";
import {prepareSQFTData} from "../../sqft/components/canvas/core/workspace/workspaceDataMapper";
import {saveSQFTDataToQuote} from "../../sqft/helpers/sqftQuotesHelper";
import {setReCacheMenuCounter} from "../../../actions/sqftMenuFunctions";
import {hardCodeIsKitchenMagic} from "../../../misc/fabricatorHardcode";

const filterNavItemsWithSearch = (navItems, productText) => {
  if (!productText) {
    return navItems
  }
  const searchString = productText.toLowerCase();
  return navItems.filter(navItem => {
    const name = navItem && navItem.part && navItem.part.getFeatureName ? navItem.part.getFeatureName() : "";
    return name && name.toLowerCase().includes(searchString)
  })
}

const SqftFeaturesPopupTitleFeatureDropdown = (props) => {
  const { featureGroup, editButtonColor, rebuildQuoteLists, reCacheMenuCounter, setReCacheMenuCounter } = props;
  //const { wizardIsActive, visualizerType } = props;
  let featureGroupSubPart = featureGroup.subPart ? featureGroup.subPart.part : featureGroup;
  const feature = featureGroupSubPart.activeFeature || featureGroupSubPart.activeNotInVisualizerFeature;

  const [productText, setProductText] = useState("");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [ignored, forceUpdate] = useReducer(x => x + 1, 0);
  const dropdownElement = useRef(null);
  const inputElement = useRef(null);

  useOutsideClick(dropdownElement, () => {
    setDropdownVisible(false);
  }, true);

  const handleInputChange = (event) => {
    setProductText(event.target.value);
  }

  const handleNavItemClick = async (navItem) => {
    navItem.part.handleClick();
    sqftShapeManager.changeShapesFeatureIDIfColorWasChanged(navItem.part);

    //let updatedList = {...parentsList};
    //let updatedLists = [...parentsLists];

    // const parentListIndex = parentsLists.findIndex(pList => pList === parentsList);
    // updatedList[parentKey].features[sqftFeatureIndex].feature = navItem.part;
    // if (navItem.newWizardGroupId) {
    //   // updatedList[parentKey].features[sqftFeatureIndex].fromWizardGroupId = navItem.newWizardGroupId;
    //   // we can't do that, we need to have all features, from all groups, so we can't pass direct group id here
    //   updatedList[parentKey].features[sqftFeatureIndex].newWizardGroupId = navItem.newWizardGroupId;
    //   // console.log("updated!", updatedList[parentKey].features[sqftFeatureIndex]);
    // }

    //updatedLists[updatedLists.findIndex(list => list === parentsList)] = updatedList;
    //setParentsLists(updatedLists);

    let sqftCalcData = await prepareSQFTData();
    await saveSQFTDataToQuote(sqftCalcData);
    // wi will update parent list on quotes change
    void rebuildQuoteLists;

    setDropdownVisible(false);
    setReCacheMenuCounter(reCacheMenuCounter + 1);
  };

  const getNamesArray = () => {
    if (dropdownVisible) {
      if (!featureGroupSubPart) {
        return [{loader: true}]
      }
      // here wi will return wizard nav items but if they arent exist, then we take them from featureGroup
      // if (wizardIsActive) {
      //   let wizNavItems = getNavItemsFromTheWizard({part: featureGroupSubPart}, "", {}, null, visualizerType, true);
      //   wizNavItems = filterNavItemsWithSearch(wizNavItems, productText);
      //   if (wizNavItems.length !== 0) {
      //     return wizNavItems
      //   }
      // }
      const layout = getCurrentLayout();
      const navItems = layout.designNavigationItems(
        { part: featureGroup },
        [],
        "",
        null,
        "all",
        [],
        { firstFeature: null, firstConditions: null },
      );
      return filterNavItemsWithSearch(navItems, productText);
    }
    return []
  }

  const editButtonClick = () => {
    if (dropdownVisible) {
      setDropdownVisible(false)
    } else {
      setDropdownVisible(true);
      if (inputElement && inputElement.current) {
        inputElement.current.focus()
      }
    }
  };

  const namesArray = getNamesArray();
  const isKitchenMagic = hardCodeIsKitchenMagic()
  const getNavItemName = (navItem) => {
    return (
      !isKitchenMagic
      ? <FeatureName feature={navItem.part}/>
      : navItem.part.getSplittedFeatureName()
          // .replace(' 1 Northern Contours', '')
          // .replace(' 1 Kitchen Magic', '')
          // .replace(' 1 Decore-ative Specialties', '')
    )
  };

  const styles = {
    height: dropdownVisible ? namesArray.length * 30 + 32 : 0,
    width: dropdownVisible ? "100%" : 0,
  }

  return (
    <div className="sqft-popup__feature-name" ref={dropdownElement}>
      <button className="sqft-popup__feature-edit" onClick={editButtonClick} >
        <EditIcon color={editButtonColor}/>
      </button>
      {feature
        ? <FeatureName feature={feature}/>
        : <FormattedMessage id="sqftFeaturesPopup.noFeatureSelected"/>}
      <div className="sqft-popup__dropdown aq-dropdown" style={styles}>
        <input className="ui-input ui-input--new ui-input--gray"
               value={productText}
               ref={inputElement}
               onChange={handleInputChange}/>
        <ul className="aq-list">
          {namesArray.map((navItem, navItemIndex) => {
            return navItem.loader ? (
              <AllFeaturesChecker subPart={{part: featureGroupSubPart}}
                                  key="aq-list-loader" ignored={ignored} callBack={forceUpdate}/>
            ) : (
              <li className="aq-list__item bold" key={navItemIndex} onClick={() => handleNavItemClick(navItem)}>
                {getNavItemName(navItem)}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

SqftFeaturesPopupTitleFeatureDropdown.propTypes = {
  editButtonColor: PropTypes.string.isRequired,
  featureGroup: PropTypes.object.isRequired,
  visualizerType: PropTypes.string.isRequired,
  parentsLists:  PropTypes.array,
  parentsList:  PropTypes.object,
  setParentsLists: PropTypes.func.isRequired,
  rebuildQuoteLists: PropTypes.func,
}

const mapStateToProps = (store) => {
  return {
    activeTheme: store.serverState.activeTheme,
    reCacheMenuCounter: store.sqftMenuState.reCacheMenuCounter,
    wizardIsActive: store.wizardState.wizardIsActive,
  };
};
const mapDispatchToProps = {
  setReCacheMenuCounter
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupTitleFeatureDropdown)
